import WebhooksCreateView from "@saleor/webhooks/views/WebhooksCreate";
import React from "react";
import { Route, useParams } from "react-router-dom";

import { webhookAddPath, webhookPath } from "./urls";
import WebhooksDetails from "./views/WebhooksDetails";

const WebhookDetails: React.FC = () => {
  const { id } = useParams();
  return <WebhooksDetails id={decodeURIComponent(id)} />;
};

const WebhookCreate: React.FC = () => {
  const { id } = useParams();
  return <WebhooksCreateView id={decodeURIComponent(id)} />;
};

const Component = () => (
  <>
    <Route path={webhookAddPath(":id")} element={<WebhookCreate />} />
    <Route path={webhookPath(":id")} element={<WebhookDetails />} />
  </>
);

export default Component;
